import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { TreeTransparente } from './styles';
import { Tree, Tooltip, Typography } from '~/components';
import { bindAntTreeInputA11y } from '~/modules/Helper/antdTreeA11y.helper';

function TreeViewEstruturaOrganizacional({ treeView, history }) {
  const { TreeNode } = Tree;
  const { corTema } = useSelector(state => state.configuration);
  const treeWrapRef = useRef(null);

  useEffect(
    () =>
      bindAntTreeInputA11y(
        treeWrapRef.current,
        'Navegação da estrutura organizacional'
      ),
    [treeView]
  );

  function navigateToItem(item) {
    if (item.Externo) window.open(item.Link);
    else history.push(`/estrutura_organizacional/detalhe/${item.IdDetalhe}`);
  }

  function handleActivate(event, item) {
    if (
      event.type === 'click' ||
      event.key === 'Enter' ||
      event.key === ' ' ||
      event.keyCode === 13
    ) {
      if (event.type === 'keydown') event.preventDefault();
      navigateToItem(item);
    }
  }

  function renderTitle(item) {
    return (
      <Tooltip title="Acesso" placement="topLeft">
        <Typography.Text
          style={{ display: 'block', width: '100%', outline: 0 }}
        >
          <span
            style={{
              color: corTema,
              cursor: 'pointer',
              width: '100%',
              display: 'block',
              outline: 0,
            }}
            onClick={event => handleActivate(event, item)}
            onKeyDown={event => handleActivate(event, item)}
            role="link"
            tabIndex={0}
            aria-label={`Acessar ${item.title}`}
          >
            {item.title}
          </span>
        </Typography.Text>
      </Tooltip>
    );
  }

  const loop = data =>
    (Array.isArray(data) ? data : []).map(item => {
      if (item.children && item.children.length && item.Habilitado) {
        return (
          <TreeNode key={item.key} title={renderTitle(item)}>
            {loop(item.children)}
          </TreeNode>
        );
      }
      if (item.Habilitado) {
        return <TreeNode key={item.key} isLeaf title={renderTitle(item)} />;
      }
      return null;
    });

  const nodes = loop(treeView).filter(Boolean);

  if (!nodes.length) {
    return (
      <Typography.Paragraph style={{ marginBottom: 0 }}>
        Nenhum item disponível na estrutura organizacional.
      </Typography.Paragraph>
    );
  }

  return (
    <div ref={treeWrapRef}>
      <TreeTransparente
        className="draggable-tree estrutura-organizacional-tree"
        draggable={false}
        defaultExpandAll={false}
        blockNode
        autoExpandParent={false}
        selectable
      >
        {nodes}
      </TreeTransparente>
    </div>
  );
}

export default TreeViewEstruturaOrganizacional;
